<button 
  mat-button
  [disabled]="disabled || loading"
  [class]="classNames"
  [ngStyle]="customNgStyle"
  [ngClass]="customNgClass"
  (click)="buttonEvent.emit($event)"
>
  <div *ngIf="loading" class="spinner"></div>
  <ng-content></ng-content>
</button>
